<div class="guide-section">
  <div class="row">
    <div class="guide-section__title" style="padding-top: 40px">
      Preferred delivery service
      <div class="guide-section__subtext">Select the carrier to use for this method</div>
    </div>
    <div class="content__recommended-delivery">
      <div class="content__recommended-delivery__title">
        Preferred delivery service
        @if (this.formGroup.get('carrierId').valid) {
          <div class="active-accordion">
            <img src="assets/checkout-icons/active-accordion.svg" alt="" />
          </div>
        }
      </div>
      <form [formGroup]="formGroup">
        <div class="row" style="margin-top: 25px">
          <div style="margin-top: 1.1rem; display: flex; gap: 8px">
            <div class="content__recommended-delivery__input">
              <div class="content__general-settings__text">Choose delivery service</div>
              <div class="carrier-autocomplete-mat-field">
                <img
                  class="content__recommended-delivery__input__icon"
                  src="assets/checkout-icons/search-icon.svg"
                  alt="" />
                <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                <input
                  placeholder="Search from connected carriers"
                  class="pdq-mat-input"
                  matInput
                  #carriersAutocomplete
                  formControlName="carrierId"
                  id="search-carrier"
                  type="text"
                  [(ngModel)]="searchCarrier"
                  [matAutocomplete]="auto" />
                <div style="margin-left: 15px">
                  <mat-autocomplete #auto="matAutocomplete" class="pdq-mat-select--panel" [displayWith]="getDisplayFn">
                    @if (isCarrierAutocompleteLoading) {
                      <mat-option class="is-loading">
                        <span style="justify-content: center; display: flex">
                          <mat-spinner diameter="25" [color]="'#22214C'"></mat-spinner>
                        </span>
                      </mat-option>
                    }

                    @if (!isCarrierAutocompleteLoading) {
                      @for (carrier of carrierAutocompleteResults; track carrier) {
                        <mat-option
                          (onSelectionChange)="onCarrierSelected($event)"
                          (click)="$event.preventDefault()"
                          [value]="carrier">
                          {{ carrier?.name }}
                        </mat-option>
                      }
                    }
                  </mat-autocomplete>
                </div>
              </div>
            </div>
            <input
              class="default-delivery-service__sla-time"
              type="number"
              (wheel)="$event.preventDefault()"
              (scroll)="$event.preventDefault()"
              min="0"
              formControlName="SLABDays"
              placeholder="Maximal transit {{ shippingMethodCategory === 'local' ? 'hours' : 'days' }}" />
          </div>
        </div>
      </form>

      <form [formGroup]="shipmentExtrasFormGroup">
        @if (isActiveServiceProviders) {
          <div style="margin-bottom: 10px">
            <span class="default-delivery-service__subtitle"> Active service providers </span>
            @if (displayProvidersInfoOrServiceLevels === 'providerServices') {
              <pdq-radio-group (onChange)="onProvierServiceLevelSelected($event)">
                @for (service of providerServices; track service) {
                  <pdq-radio-button
                    [text]="service"
                    [value]="service"
                    [checked]="service === carrierMetadata?.carrier_settings?.providerService">
                  </pdq-radio-button>
                }
              </pdq-radio-group>
            } @else {
              @for (provider of activeCarrier?.providers; track provider) {
                <pdq-checkbox
                  labelSize="small"
                  [checked]="selectedActiveProviders?.includes(provider.name?.toLowerCase())"
                  (onChange)="onProviderSelect($event, provider)"
                  [label]="getProviderDisplayNameMap(provider)">
                </pdq-checkbox>
              }
            }
          </div>
        }

        @if (isActiveCarrierHaveShipmentExtrasFields) {
          <div style="margin-bottom: 20px">
            <div class="advanced-settings" (click)="isCarrierAdvancedSettings = !isCarrierAdvancedSettings">
              Advanced settings
              <img
                class="advanced-settings__trend"
                src="assets/icons/triangle.svg"
                [ngClass]="{ up: isCarrierAdvancedSettings, down: !isCarrierAdvancedSettings }" />
            </div>
            @if (isCarrierAdvancedSettings) {
              <div>
                <div class="default-delivery-service__subtitle">
                  Enable shipment extras
                  <!-- <pdq-icon style="margin-top: auto" [icon]="'more_information'"></pdq-icon> -->
                </div>
                @for (shipmentFields of shipmentExtrasFields; track shipmentFields) {
                  <div>
                    @if (shipmentFields.type == fieldsTypes.CHECKBOX) {
                      <div>
                        <pdq-checkbox
                          labelSize="small"
                          [label]="shipmentFields.displayName"
                          [icon]="shipmentFields.infoIcon ? 'more_information' : null"
                          [description]="shipmentFields.description ? shipmentFields.description : ''"
                          formControlName="{{ shipmentFields.fieldName }}">
                        </pdq-checkbox>
                      </div>
                    }
                    @if (shipmentFields.type == fieldsTypes.RADIO_BUTTONS) {
                      <div>
                        <pdq-radio-group
                          class="default-delivery-service__subtitle"
                          formControlName="{{ shipmentFields.fieldName }}"
                          [label]="shipmentFields.placeholder || shipmentFields.displayName || ''"
                          [description]="shipmentFields.description ? shipmentFields.description : ''">
                          @for (option of shipmentFields.options; track option) {
                            <pdq-radio-button
                              [text]="option.name"
                              [value]="option.value"
                              [checked]="option.value === getShipmentExtrasFieldValue(shipmentFields.fieldName)">
                            </pdq-radio-button>
                          }
                        </pdq-radio-group>
                      </div>
                    }
                    <div
                      class="input-arrows"
                      [ngClass]="{
                        dryIceWeightUnit: shipmentFields.fieldName === 'dryIceWeightUnit',
                        insuranceAmountType: shipmentFields.fieldName === 'insuranceAmountType',
                      }">
                      @if (shipmentFields.type == fieldsTypes.NUMBER) {
                        <pdq-input-arrows
                          placeholder="{{ shipmentFields.placeHolder }}"
                          [precision]="shipmentFields.numberType === 'double' ? '1' : '0'"
                          formControlName="{{ shipmentFields.fieldName }}"
                          type="number"
                          mode="{{ shipmentFields.mode }}"
                          [disabled]="!shipmentExtrasFormGroup.controls[shipmentFields.requiredFieldName].value">
                        </pdq-input-arrows>
                      }
                      <div style="margin: 8px 0">
                        @if (shipmentFields.type == fieldsTypes.SELECT) {
                          <pdq-dropdown
                            [options]="shipmentFields.options"
                            placeholder="{{ shipmentFields.placeHolder }}"
                            formControlName="{{ shipmentFields.fieldName }}"
                            [defaultOption]="
                              findDefaultOption(
                                shipmentFields.options,
                                shipmentExtrasFormGroup.controls[shipmentFields.fieldName]
                              )
                            "
                            [disabled]="!shipmentExtrasFormGroup.controls[shipmentFields.requiredFieldName].value">
                          </pdq-dropdown>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </form>
    </div>
  </div>
</div>
